export default __webpack_public_path__ + "static/media/Accueil.63966c05.png";